import { render, staticRenderFns } from "./TranslationNavigation.vue?vue&type=template&id=2df73c6e"
import script from "./TranslationNavigation.vue?vue&type=script&lang=js"
export * from "./TranslationNavigation.vue?vue&type=script&lang=js"
import style0 from "./TranslationNavigation.vue?vue&type=style&index=0&id=2df73c6e&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports